"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteContentExplanation = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
function ExplanationPart(_a) {
    var items = _a.items;
    return (react_1.default.createElement(react_1.default.Fragment, null, items.map(function (item, index) {
        return (react_1.default.createElement("div", { className: "delete-content-explanation-container", key: index },
            react_1.default.createElement("i", { className: "content-deletion-icon ".concat(item.icon) }),
            react_1.default.createElement("p", null, item.text)));
    })));
}
function DeleteContentExplanation(_a) {
    var willBeDeleted = _a.willBeDeleted, willNotBeDeleted = _a.willNotBeDeleted;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("h4", { className: "delete-content-explanation-title" }, t('settings:DATA_AND_PRIVACY.WILL_BE_DELETED_LABEL')),
            react_1.default.createElement(ExplanationPart, { items: willBeDeleted })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("h4", { className: "delete-content-explanation-title" }, t('settings:DATA_AND_PRIVACY.WILL_NOT_BE_DELETED_LABEL')),
            react_1.default.createElement(ExplanationPart, { items: willNotBeDeleted }))));
}
exports.DeleteContentExplanation = DeleteContentExplanation;
